import { computed } from 'vue';

const DEFAULT_LEADSTER_BASE_URL = 'https://app.leadster.com.br/';

export function useLeadsterUrls() {
  const leadsterBaseUrl = computed(
    () => import.meta.env.VITE_LEADSTER_APP_URL || DEFAULT_LEADSTER_BASE_URL
  );

  const buildLeadsterUrl = (path, fallback, searchParams = {}) => {
    try {
      const url = new URL(path, leadsterBaseUrl.value);
      Object.entries(searchParams).forEach(([key, value]) => {
        if (value != null && value !== '') {
          url.searchParams.set(key, value);
        }
      });
      return url.toString();
    } catch {
      return fallback;
    }
  };

  const scriptsUrl = computed(() =>
    buildLeadsterUrl(
      '/scripts',
      `${DEFAULT_LEADSTER_BASE_URL}scripts?script_kind=whatsapp`,
      { script_kind: 'whatsapp' }
    )
  );
  const websiteScriptsUrl = computed(() =>
    buildLeadsterUrl(
      '/scripts',
      `${DEFAULT_LEADSTER_BASE_URL}scripts?script_kind=website`,
      { script_kind: 'website' }
    )
  );
  const leadsterAiUrl = computed(() =>
    buildLeadsterUrl(
      '/ai/leadster',
      `${DEFAULT_LEADSTER_BASE_URL}ai/leadster?agent_action=whatsapp`,
      { agent_action: 'whatsapp' }
    )
  );
  const websiteLeadsterAiUrl = computed(() =>
    buildLeadsterUrl(
      '/ai/leadster',
      `${DEFAULT_LEADSTER_BASE_URL}ai/leadster?agent_action=website`,
      { agent_action: 'website' }
    )
  );
  const leadsDashboardUrl = computed(() =>
    buildLeadsterUrl('/', DEFAULT_LEADSTER_BASE_URL)
  );
  const leadsUrl = computed(() =>
    buildLeadsterUrl('/leads', `${DEFAULT_LEADSTER_BASE_URL}leads`)
  );
  const marketingIntegrationsUrl = computed(() =>
    buildLeadsterUrl(
      '/integrations',
      `${DEFAULT_LEADSTER_BASE_URL}integrations`
    )
  );
  const scriptsAppLabel = computed(() => {
    try {
      return new URL(leadsterBaseUrl.value).host;
    } catch {
      return 'app.leadster.com.br';
    }
  });

  return {
    leadsterBaseUrl,
    scriptsUrl,
    websiteScriptsUrl,
    leadsterAiUrl,
    websiteLeadsterAiUrl,
    leadsDashboardUrl,
    leadsUrl,
    marketingIntegrationsUrl,
    scriptsAppLabel,
  };
}
